import { Col, Container, Row } from "react-bootstrap";

function BottomAnchor(props) {
    const letters = buildAlphabetLetters(props.favouriteGames);

    if (letters.length === 0) return null;

    return (
        <div className="fixed-bottom" style={{ background: '#12071e', borderTop: '1px solid rgba(255,255,255,0.1)', boxShadow: '0 -2px 12px rgba(0,0,0,0.3)' }}>
            <Container>
                <Row className="py-1 flex-nowrap overflow-auto" style={{ scrollbarWidth: 'none' }}>
                    <Col xs="auto">
                        <a href="#" className="text-white-50 text-decoration-none fw-semibold small">↑ TOP</a>
                    </Col>
                    {letters.map((letter, index) => (
                        <Col key={index} xs="auto" className="px-1">
                            <a href={"#" + letter} className="text-white text-decoration-none fw-semibold small">{letter}</a>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

function buildAlphabetLetters(favouriteGames) {
    return [...new Set(favouriteGames.map((game) =>
        game.name ? game.name.trim().charAt(0) : ""
    ).filter(Boolean))];
}

export default BottomAnchor;